import React, { Component } from 'react';
import { Alert } from 'react-bootstrap';
import { PropTypes } from 'prop-types';

import './Modal.css';
import brandingStyles from '../branding/brandingStyles';
import { namespace } from '../../../config.json';

class DisplayKeyComponent extends Component {
    constructor() {
        super();
        this.state = {
            showSecret: false,
        };
        this.buttonClick = this.buttonClick.bind(this);
    }

    buttonClick() {
        this.setState({ showSecret: true });
    }

    render() {
        let secret = null;
        if (this.state.showSecret) {
            secret = ` ${this.props.access.SecretAccessKey}`;
        } else {
            secret = <button className="btn btn-primary btn-xs"
              id="show-access-key-button"
              onClick={this.buttonClick}>
                <i className="fa fa-eye"></i><span>&nbsp;</span>
                Show
            </button>;
        }

        return (
            <div>
                <div className="alert alert-warning">
                    <i className="fa fa-exclamation-triangle"
                      style={{
                          color: 'orange',
                      }}></i>
                      <span>&nbsp;</span>
                      This is the only time that the secret access key can be
                      viewed. However, you can create a new access key at any
                      time.
                </div>
                <hr/>
                <pre>
                  <strong>Username</strong>
                   : {this.props.access.UserName}<br/>
                  <strong>AccessKey</strong>
                   : {this.props.access.AccessKeyId}<br/>
                  <strong>SecretAccessKey</strong>:
                    {secret}
                </pre>
            </div>
        );
    }
}

DisplayKeyComponent.propTypes = {
    access: PropTypes.object.isRequired,
};

class CreateKeyButtonComponent extends Component {

    constructor() {
        super();
        this.state = {
            showModal: false,
            key: null,
            modalErrorAlert: '',
        };

        this.openOp = this.openOp.bind(this);
        this.submit = this.submit.bind(this);
        this.reset = this.reset.bind(this);
    }

    // Open
    openOp() {
        this.setState({ showModal: true });
    }

    // Fired when modal is submitted
    submit() {
        this.props.createKey(this.props.username).then(res => {
            let key = {};
            if (res.hasOwnProperty('key')) {
                key = {
                    UserName: this.props.username,
                    AccessKeyId: res.key.id,
                    SecretAccessKey: res.key.value,
                };
            } else {
                key = res.accessKey;
            }

            this.setState({ key });
            // Calling callback if provided
            if (this.props.callback) {
                this.props.callback();
            }
        }
        ).catch(message => {
            if (message.status === 401 || message.status === 403) {
                window.location.href =
                    `${namespace}/login/error/${message.status}`;
            } else {
                this.setState({
                    modalErrorAlert: `Unable to process the request as the
                                      server returned an Internal Error.`,
                });
            }
        }
        );
    }

    // Reset the component for an other key generation
    reset() {
        this.setState({ key: null });
    }

    render() {
        // Setting up error node in case of an error
        let errorAlert = null;

        if (this.state.modalErrorAlert.length) {
            errorAlert = <Alert bsStyle="danger" style={{ marginTop: '10px' }}>
                        {this.state.modalErrorAlert}
                      </Alert>;
        }

        let toggle = null;
        // The key hasn't been set we display the action button
        if (!this.state.key) {
            // The key has been received. We hide the button and display it
            toggle = <div>
                <p>
                    {'You are about to generate an access key for '}
                    {this.props.userType}
                    {' "'}
                    {this.props.username}
                    {'".'}
                </p>
                <button
                  className="btn btn-primary"
                  style={brandingStyles.buttons.primary}
                  onClick={ this.submit }>Proceed</button>
                {errorAlert}
              </div>;
        } else {
            toggle = <div>
                <DisplayKeyComponent access={ this.state.key }/>
                <button
                  className="btn btn-primary"
                  style={brandingStyles.buttons.primary}
                  onClick={ this.reset }
                >
                  Generate another key
                </button>
              </div>;
        }

        let op = null;
        if (this.state.showModal) {
            op = toggle;
        } else {
            op = <button
                className="btn btn-primary"
                style={brandingStyles.buttons.primary}
                onClick={this.openOp}
            >
                <i className="fa fa-plus"></i>
                <span>&nbsp;</span>
                Generate a new key
            </button>;
        }

        return (
            <div>{op}</div>
        );
    }

}

// Username is mandatory for delete operation to work
CreateKeyButtonComponent.propTypes = {
    username: PropTypes.string.isRequired,
    userType: PropTypes.string.isRequired,
    createKey: PropTypes.func.isRequired,
    callback: PropTypes.func,
};

export default CreateKeyButtonComponent;



/** WEBPACK FOOTER **
 ** ./src/components/CreateKeyButton.js
 **/